import {
  GET_EVENTS_SUCCESS,
  GET_EVENTS_FAIL,
  ADD_EVENT_SUCCESS,
  ADD_EVENT_FAIL,
  UPDATE_EVENT_SUCCESS,
  UPDATE_EVENT_FAIL,
  DELETE_EVENT_SUCCESS,
  DELETE_EVENT_FAIL,
  DELETE_MONTH_EVENTS_SUCCESS,
  DELETE_MONTH_EVENTS_FAIL,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORIES_FAIL,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_ERROR,
  PROFILE_SUCCESS,
  PROFILE_ERROR
} from "./actionTypes"

const INIT_STATE = {
  events: [],
  categories: [],
  error: {},
  user: {},
}

const Calendar = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_EVENTS_SUCCESS:
      return {
        ...state,
        events: action.payload,
      }

    case GET_EVENTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case ADD_EVENT_SUCCESS:
      return {
        ...state,
        events: [...state.events, action.payload],
      }

    case ADD_EVENT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_EVENT_SUCCESS:
      console.log(action.payload)
      return {
        ...state,
        events: state.events.map(event =>
          event.id.toString() === action.payload.id.toString()
            ? { event, ...action.payload }
            : event
        ),
      }

    case UPDATE_EVENT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case DELETE_EVENT_SUCCESS:
      return {
        ...state,
        events: state.events.filter(
          event => event.id.toString() !== action.payload.id.toString()
        ),
      }

    case DELETE_EVENT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case DELETE_MONTH_EVENTS_SUCCESS:
      console.log ("Deleted events", action.payload)
      return {
        ...state,
        events: state.events.filter(
            event => !action.payload.includes(event.id.toString())
        )
      }

    case DELETE_MONTH_EVENTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }


    case GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        categories: action.payload,
      }

    case GET_CATEGORIES_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_PROFILE_SUCCESS:
      return { ...state, user: action.payload }
    case GET_PROFILE_ERROR:
      return { ...state, error: action.payload }
    case PROFILE_SUCCESS:
      return { ...state, user: action.payload }
    case PROFILE_ERROR:
      return { ...state, error: action.payload }
    default:
      return state
  }
}

export default Calendar
